import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { InvoicingRepository } from '@packlink/packlink-sdk';
import { TransactionFilters } from '../pages/SettingsTransactions/TransactionsFilters';
import { apiClient } from '@sdk';

export const DEFAULT_PAGINATION = {
    pageSize: 10,
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalElements: 0,
    },
};

const invoicingRepository = new InvoicingRepository(apiClient);

export function useTransactions(filters: TransactionFilters, page = 1) {
    const { data, isLoading, isRefetching } = useQuery({
        queryKey: ['transactions', filters, page],
        queryFn: async () => {
            return invoicingRepository.getTransactions({
                orderReference: filters.id,
                from: filters.from,
                to: filters.to,
                page,
            });
        },
        placeholderData: keepPreviousData,
    });

    return {
        items: data?.items || [],
        pagination: data?.pagination,
        isLoading,
        isRefetching,
    };
}
